import styled from 'styled-components'

import { Icon } from '../icon/Icon'

type AnimatedArrowIconProps = {
  rotate: string
}

const AnimatedIcon = styled(Icon)<AnimatedArrowIconProps>`
  transition: rotate ease-in-out 200ms;
  rotate: ${props => props.rotate};
`

export function AnimatedArrowIcon(expanded: boolean) {
  return (
    <AnimatedIcon
      name="arrows-expanded"
      data-testid="icon-expand"
      rotate={expanded ? '180deg' : '0deg'}
    />
  )
}
